var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.49996H2.91667M2.91667 3.49996H12.25M2.91667 3.49996V11.6666C2.91667 11.976 3.03958 12.2728 3.25838 12.4916C3.47717 12.7104 3.77391 12.8333 4.08333 12.8333H9.91667C10.2261 12.8333 10.5228 12.7104 10.7416 12.4916C10.9604 12.2728 11.0833 11.976 11.0833 11.6666V3.49996M4.66667 3.49996V2.33329C4.66667 2.02387 4.78958 1.72713 5.00838 1.50833C5.22717 1.28954 5.52391 1.16663 5.83333 1.16663H8.16667C8.47609 1.16663 8.77283 1.28954 8.99162 1.50833C9.21042 1.72713 9.33333 2.02387 9.33333 2.33329V3.49996",
    stroke: "#3F3F3F",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon-trash.07e0c8d3253b2346682feb4a132ab368.svg";
export { ForwardRef as ReactComponent };